module.exports = __webpack_public_path__ + "img/Artificially.7761a57a.svg";